import { SET_MODAL } from "../actions/modal";

const initialState = {};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_MODAL : {      
            if(action.action === null){
                /* Hide modal */
                document.getElementById(`modal-${state}`).classList.add('hideModal');
            }   
            /* Show modal */
            if(document.getElementById(`modal-${action.action}`)){
                document.getElementById(`modal-${action.action}`).classList.remove('hideModal');
            }
            return action.action;
        }
      default:
        return state;
    }
  }
  